import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInterview } from '../../utils/interviewContext';
import { trackPostHogEvent } from '../../utils/posthogUtils';
import styles from './Decision.module.css';
import { Collapse } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import Footer from '../.shared/footer/footer';
import ProgressBar from '../.shared/ProgressBar/ProgressBar';
import Header from '../.shared/header/header';

export default function Decision() {
    const navigate = useNavigate();
    const { updateInterviewData, interviewData } = useInterview();
    const [ selectedChoice, setSelectedChoice ] = useState('none');

    // Populate from localStorage on component mount
    useEffect(() => {
        if (interviewData.decision) {
            setSelectedChoice(interviewData.decision);
        }
    }, [interviewData.decision]);

    // Track when user reaches the decision page
    useEffect(() => {
        trackPostHogEvent('interview_step_viewed', {
            interview_step: 'decision',
            step_number: 0,
            step_type: 'entry_point'
        });
    }, []);
    

    const handleConfirm = (recentlyChosen) => {

        if (selectedChoice === 'none' && !recentlyChosen) return;

        const chosenDecision = recentlyChosen ? recentlyChosen : selectedChoice;

        selectedChoice !== chosenDecision && setSelectedChoice(chosenDecision);

        // Define next destination based on decision
        const nextDestination = chosenDecision === 'help_choose' ? '/interview/bestyou' : '/products';

        // Timeout to allow button selection animation to complete
        setTimeout(() => {
            // Save decision to interview context
            updateInterviewData('decision', chosenDecision);
            
            // Track decision selection
            trackPostHogEvent('interview_decision_selected', {
                decision: chosenDecision,
                interview_step: 'decision',
                step_number: 0,
                next_destination: nextDestination
            });
            
            navigate(nextDestination);
        }, 300);

    };

    return (
        <>
            <div className={styles.interviewPageContainer}>
                <Header />
                <ProgressBar progress={25} />
                <Collapse
                    in
                    appear
                    timeout={500}
                    unmountOnExit
                    mountOnEnter
                    orientation="vertical"
                >
                    <div className={styles.decisionContent}>
                        <h1 className={styles.title}>Are you ready to choose or would you like some help?</h1>
                        <div className={styles.buttonsContainer}>
                            <button className={`${styles.interviewButton} ${selectedChoice === 'ready' ? styles.selected : ''}`} onClick={() => handleConfirm('ready')}>
                                <CheckRoundedIcon sx={{ color: `${selectedChoice === 'ready' ? '#0D79FE' : '#4E4E4EFD'}` }} />
                                <span>I'm Ready</span>
                            </button>
                            <button className={`${styles.interviewButton} ${selectedChoice === 'help_choose' ? styles.selected : ''}`} onClick={() => handleConfirm('help_choose')}>
                                <HelpRoundedIcon sx={{ color: `${selectedChoice === 'help_choose' ? '#0D79FE' : '#4E4E4EFD'}` }} />
                                <span>Help Me Choose</span>
                            </button>

                            <div className={styles.confirmationButtons}>
                                <button 
                                    className={styles.secondaryButton}
                                    onClick={() => navigate('/')}
                                >
                                    Back
                                </button>
                                <button 
                                    className={`${styles.primaryButton} ${selectedChoice === 'none' ? styles.disabledButton : ''}`}
                                    onClick={() => handleConfirm()}
                                >
                                    Confirm
                                </button>
                            </div>

                        </div>
                    </div>
                </Collapse>
            </div>
            <Footer />
        </>
    );
}
